import { IconCheckDefault, IconCopyOutline } from '@iwoca/icons';
import { clsx } from 'clsx';

import { useCopyEmail } from '../../hooks/useCopyEmail';

export const CopyEmailLink = ({ email }: { email: string | null }) => {
  const { copied, onCopy } = useCopyEmail(email);

  if (email === null) return null;

  return (
    <button
      type="button"
      onClick={onCopy}
      className={clsx(
        'flex w-max cursor-pointer items-center gap-s border-none bg-transparent p-0 text-s font-bold',
        copied ? 'text-success-mid' : 'text-primary-40',
      )}
    >
      {/* Also the button's accessible name, so this announces once, not twice. */}
      <span aria-live="polite">
        {copied ? 'Copied to clipboard' : 'Copy email to clipboard'}
      </span>
      {copied ? (
        <IconCheckDefault height="18" width="18" aria-hidden />
      ) : (
        <IconCopyOutline height="18" width="18" aria-hidden />
      )}
    </button>
  );
};
